import React, { FC } from 'react';
import { BaseSizes, ExtraLevels, Heading, Modal, TextVariant, Text, BaseLevels } from '@kb-front/ui-kit';

import { translate } from 'shared/utils/translation';
import Info from 'shared/assets/images/circle-info.svg';

import './index.scss';

interface IProps {
  getInfoModalData: any[];
  isVisibleGiftCardModal: boolean;
  setIsVisibleGiftCardModal: (value: boolean) => void;
}

const GiftCardModal: FC<IProps> = ({ getInfoModalData, isVisibleGiftCardModal, setIsVisibleGiftCardModal }) => {
  return (
    <Modal
      onClose={() => setIsVisibleGiftCardModal(false)}
      visible={isVisibleGiftCardModal}
      size={BaseSizes.S}
      header={
        <Heading level={ExtraLevels.L5}>
          <div>{translate('scoring.giftCard.title')}</div>
        </Heading>
      }
    >
      <div className="gift__card__modal">
        {getInfoModalData?.map(item => (
          <div className="gift__card__modal-element" key={item?.value}>
            <Text variant={TextVariant.SECONDARY} level={BaseLevels.L2}>
              {item?.name}
            </Text>
            <Text variant={item.isFree && TextVariant.SUCCESS}>{item?.value}</Text>
          </div>
        ))}

        <div className="gift__card__modal-info">
          <div className="gift__card__modal-info-img">
            <img src={Info} alt="photo" />
          </div>
          <Text variant={TextVariant.DEFAULT} level={BaseLevels.L3}>
            {translate('scoring.giftMoreInfoModal.note')}
          </Text>
        </div>
      </div>
    </Modal>
  );
};

export default GiftCardModal;
